import PropTypes from 'prop-types';
import React from 'react';

import {pie as d3Pie, arc as d3Arc} from "d3-shape";

import {FlexLayerGroup} from "./Canvas.jsx";
import {ChartBaseContent} from './Chart.jsx';

const HILIGHT_OPACITY = 1.0;
const NON_HILIGHT_OPACITY = 0.3;

export class PieChartContent extends ChartBaseContent {
    static displayName = 'PieChartContent';

    doDraw() {
        super.doDraw();

        let {colors, data, hoveredItem} = this.props;

        let {width, height} = this.getSize();

        let yKey = data.keys("y"),
            groupBy = data.keys("group"),
            items = data.values();


        let ctx = this.getCtx();

        if (items.length === 0) {
            return;
        }

        ctx.save();
        ctx.beginPath();

        ctx.globalAlpha = HILIGHT_OPACITY;

        let radius = (Math.min(width, height) / 2) - 50;

        let drawArc = d3Arc()
            .innerRadius(0)
            .context(ctx)
            .outerRadius(radius);

        let pieGenerator = d3Pie()
            .sort(null)
            .value(d => d[yKey]);

        let center = {x: width / 2, y: height / 2};

        ctx.translate(center.x, center.y);

        let pie = pieGenerator(items);

        for (let slice of pie) {
            let group = slice.data[groupBy];

            if (hoveredItem) {
                if (hoveredItem[groupBy] == group) {
                    ctx.globalAlpha = HILIGHT_OPACITY;
                    if ((slice.endAngle - slice.startAngle) * radius < 4) {
                        slice = {...slice, endAngle: slice.startAngle + 4 / radius};
                    }
                } else {
                    ctx.globalAlpha = NON_HILIGHT_OPACITY;
                }
            }

            ctx.beginPath();
            ctx.fillStyle = colors.get(group);
            drawArc(slice);
            ctx.fill();
        }

        ctx.restore();

        this._reverseLookup = (x, y) => {
            let dist2 = (posx, posy) => Math.pow(center.x - posx, 2) + Math.pow(center.y - posy, 2);
            let r2 = radius * radius;
            let isInsidePie = (posx, posy) => dist2(posx, posy) <= r2;

            if (isInsidePie(x, y)) {
                let getAngle = (posx, posy) => {
                    // canvas coordinates have reversed y, hence
                    // center.y - posy and not the other way around
                    let angle = Math.atan2(posx - center.x, center.y - posy);
                    return angle < 0 ? angle + Math.PI * 2 : angle;
                };

                let isInsideSector = (startAngle, endAngle, angle) => startAngle <= angle && endAngle >= angle;
                let _angle = getAngle(x, y);

                for (let slice of pie) {
                    let {startAngle, endAngle, data} = slice;
                    if (isInsideSector(startAngle, endAngle, _angle)) {
                        return {
                            item: data,
                            isValid: (x, y) => isInsidePie(x, y) && isInsideSector(startAngle, endAngle, getAngle(x, y))
                        };
                    }

                }

            }

            return null;
        };
    }
}


export default class PieChart extends React.PureComponent {
    static get options() {
        return {
            stack: true
        };
    }

    static get configOptions() {

        return [
            {name: "yKey", type: "keys", label: "\u2195 value key", filter: types => types.includes("number")},
            {name: "groupBy", type: "keys"}
        ];
    }

    static propTypes = {
        names: PropTypes.array,
        groups: PropTypes.array,
        nameScale: PropTypes.string,
        data: PropTypes.object,
        hoveredItem: PropTypes.object,
        colors: PropTypes.object.isRequired,
        stack: PropTypes.bool.isRequired
    };

    static defaultProps = {
        names: [],
        stack: true
    };

    render() {
        let {colors, data, groups, hoveredItem} = this.props;

        return (
            <FlexLayerGroup style={{flex: 1, alignSelf: "stretch", paddingRight: 20}}>
                <PieChartContent
                    {...this.props}
                    colors={colors}
                    data={data}
                    groups={groups}
                    hoveredItem={hoveredItem}
                />
            </FlexLayerGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/kpi/charts/PieChart.jsx